import React from 'react';
import { msalInstance, loginRequest } from './authConfig';
import InstallWizard from './components/InstallWizard';
import './Login.css';
import './App.css';
import logo from './logo_bellascelta.png';

function Login({ onLoginSuccess }) {
  const [loading, setLoading] = React.useState(false);
  const [showInstallWizard, setShowInstallWizard] = React.useState(false);
  const [deferredPrompt, setDeferredPrompt] = React.useState(null);

  React.useEffect(() => {
    msalInstance.initialize();
    
    // Detect if running as PWA
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || 
                         window.navigator.standalone || 
                         document.referrer.includes('android-app://');
    
    // Show wizard if browser mode on mobile device
    if (!isStandalone) {
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      if (isMobile) {
        setShowInstallWizard(true);
      }
    }
    
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    });
  }, []);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        setDeferredPrompt(null);
      }
    }
    setShowInstallWizard(false);
  };

  const handleLogin = async () => {
    if (loading) return;
    setLoading(true);
    
    try {
      await msalInstance.loginRedirect(loginRequest);
    } catch (error) {
      console.error('Login failed:', error);
      if (error.errorCode !== 'user_cancelled') {
        alert('Login fallito: ' + error.message);
      }
      setLoading(false);
    }
  };

  return (
    <>
      {showInstallWizard && (
        <InstallWizard 
          deferredPrompt={deferredPrompt}
          onInstall={handleInstallClick}
          onClose={() => setShowInstallWizard(false)}
        />
      )}
      
      <div className="login-container">
        <div className="login-card">
          <img src={logo} alt="Bellascelta" className="login-logo" />
          <h1>Produzione Live</h1>
          <p>Accedi con il tuo account Office365</p>
          <button className="login-btn" onClick={handleLogin} disabled={loading}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M11.4 24H0V12.6h11.4V24zM24 24H12.6V12.6H24V24zM11.4 11.4H0V0h11.4v11.4zm12.6 0H12.6V0H24v11.4z"/>
            </svg>
            {loading ? 'Accesso in corso...' : 'Accedi con Microsoft'}
          </button>
        </div>
      </div>
    </>
  );
}

export default Login;
